import { render } from "./LegalMiniLinks.vue?vue&type=template&id=3b557f2a&scoped=true"
import script from "./LegalMiniLinks.vue?vue&type=script&lang=js"
export * from "./LegalMiniLinks.vue?vue&type=script&lang=js"

import "./LegalMiniLinks.vue?vue&type=style&index=0&id=3b557f2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b557f2a"]])

export default __exports__